import {assign, partition, flatten} from 'lodash/fp'
import React, {Component} from 'react'
import {pie as d3Pie, arc as d3Arc} from 'd3-shape'

import './styles.css'

const colors = ['#f7f4f7', '#dcd3dd', '#c5b8c5', '#ad9dad', '#a18ca1', '#947392', '#80547c']
              
class PieChart extends Component {
  renderSlice = (arc, idx) => {
    const {selected, onSelected} = this.props
    return <path
      key={idx}
      d={d3Arc()(arc)}
      stroke={selected.id === arc.data.id ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)"}
      fill={colors[idx]}
      onClick={() => onSelected(arc.data)}
    />
  }
  
  render() {
    const {props} = this
    if (!props.width || !props.height || !props.data) {
      return <div />
    }

    const cx = props.width / 2
    const cy = props.height / 2
    const radius = (Math.min(props.width, props.height) - 10) / 2
    const radii = assign({outerRadius: radius, innerRadius: 0})
    const pieParams = d3Pie().value(d => d.value)(props.data).map(radii)
    const groups = flatten(partition(arc => arc.data.id !== props.selected.id, pieParams))

    return (
      <div className="pie-chart">
        <svg width={props.width} height={props.height}>
          <g transform={`translate(${cx}, ${cy})`}>
            { groups.map(this.renderSlice) }
          </g>
        </svg>
      </div>
    )
  }
}

export default PieChart



// WEBPACK FOOTER //
// ./src/components/PieChart/index.js